import type { SymbolDefinition } from "../types.ts";

// OBS: detta är en egen härledd representation, inte en IEC 60617-kopia.
// Spike A (symbol-licens) måste avslutas innan publik release.
export const contactor3p: SymbolDefinition = {
  id: "ep-contactor-3p",
  familyKey: "contactor",
  deviceKind: "contactor",
  version: "0.1.0",
  label: { sv: "Kontaktor 3-polig", en: "Contactor 3-pole" },
  description: {
    sv: "Trepolig kontaktor med spole.",
    en: "Three-pole contactor with coil.",
  },
  viewBox: "0 0 48 48",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square">
      <line x1="8" y1="4" x2="8" y2="14"/>
      <line x1="24" y1="4" x2="24" y2="14"/>
      <line x1="40" y1="4" x2="40" y2="14"/>
      <line x1="6" y1="14" x2="16" y2="26"/>
      <line x1="22" y1="14" x2="32" y2="26"/>
      <line x1="38" y1="14" x2="48" y2="26"/>
      <line x1="8" y1="34" x2="8" y2="44"/>
      <line x1="24" y1="34" x2="24" y2="44"/>
      <line x1="40" y1="34" x2="40" y2="44"/>
      <line x1="8" y1="26" x2="40" y2="26" stroke-dasharray="2 2"/>
    </g>
  `,
  terminals: [
    { id: "L1-in", kind: "phase", label: "L1", position: "top", offset: 0.167 },
    { id: "L2-in", kind: "phase", label: "L2", position: "top", offset: 0.5 },
    { id: "L3-in", kind: "phase", label: "L3", position: "top", offset: 0.833 },
    { id: "T1-out", kind: "phase", label: "T1", position: "bottom", offset: 0.167 },
    { id: "T2-out", kind: "phase", label: "T2", position: "bottom", offset: 0.5 },
    { id: "T3-out", kind: "phase", label: "T3", position: "bottom", offset: 0.833 },
    { id: "A1", kind: "control", label: "A1", position: "left", offset: 0.5 },
    { id: "A2", kind: "control", label: "A2", position: "right", offset: 0.5 },
  ],
  designationPrefix: "K",
  searchKeywords: ["kontaktor", "contactor", "K"],
};
